<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg" elevation="1">
          <v-card-title color="#f8f9fb" elevation="0">
            <v-row align="center" no-gutters>
              <v-col cols="auto">
                <span class="text-h6 font-weight-regular">{{
                  $t("bills.title")
                }}</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="4" md="3" class="px-3">
                <v-text-field
                  v-model="search"
                  label="Search"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  clearable
                  @input="sessionStorage(search)"
                ></v-text-field>
              </v-col>
              <v-col cols="auto" class="d-flex align-center">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date"
                      label="Year-Month"
                      readonly
                      v-bind="attrs"
                      outlined
                      dense
                      :style="{ maxWidth: '150px', height: '38px !important' }"
                      v-on="on"
                      clearable
                      class="pa-0 ma-0 mr-4"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" type="month" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="
                        $refs.menu.save(date);
                        getBills();
                      "
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
                <router-link to="/societyadmin/bills/add" tag="button">
                  <v-btn class="primary">
                    <v-icon left> mdi-plus </v-icon>
                    Add Bill
                  </v-btn>
                </router-link>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="bills"
            :search="search"
          >
              <template v-slot:item.title="{ item }">
                <div class="text-truncate" style="max-width: 150px">
                  {{ item.title }}
                </div>
              </template>
              <template v-slot:item.description="{ item }">
                <div class="text-truncate" style="max-width: 150px">
                  {{ item.description }}
                </div>
              </template>
              <template v-slot:item.type="{ item }">
                <div style="max-width: 150px">
                  {{ types[item.type  ] }}
                </div>
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ getFormattedDate(item.one_time_date) }}
              </template>
              <template v-slot:item.due_days="{ item }">
      {{ calculateDueDate(item.created_at, item.due_days) }}
    </template>
               <template v-slot:item.actions="{ item }">
                <v-btn
                  icon
                  color="secondary"
                  name="view_bill"
                  title="View Bill"
                  style="margin-left: -10px"
                  :to="'/societyadmin/bills/view/' + item.id"
                >
                  <img src="@/components/icons/view.svg" width="18" height="18" />
                </v-btn>
                <v-btn
                  icon
                  color="secondary"
                  name="edit_bill"
                  title="Edit Bill"
                  :to="'/societyadmin/bills/edit/' + item.id"
                >
                  <img src="@/components/icons/edit-02.svg" width="18" height="18" />
                </v-btn>
                <v-btn
                  icon
                  color="secondary"
                  name="delete_bill"
                  title="Delete Bill"
                  @click="confirmDelete(item.id)"
                >
                  <img src="@/components/icons/delete-01.svg" width="18" height="18" />
                </v-btn>
              </template>
            </v-data-table>
        </v-card>
      </v-flex>
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2"> Are you sure want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteBill(delete_id)">
              yes
            </v-btn>
            <v-btn color="primary" text @click="deleteDialog = false">
              No
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: `${this.$t("bills.headers.title")}`,
          value: "title",
        },
        {
          text: `${this.$t("bills.headers.description")}`,
          value: "description",
          class: "text-truncate",
        },
        {
          text: `${this.$t("bills.headers.type")}`,
          value: "type",
        },
        {
          text: `${this.$t("bills.headers.amount")}`,
          value: "amount",
        },
        {
          text: `${this.$t("bills.headers.amount_for_rental")}`,
          value: "amount_for_rental",
        },
        {
          text: `${this.$t("bills.headers.date")}`,
          value: "created_at",
        },
        {
          text: "Due Date",
          value: "due_days",
        },
        {
          text: `${this.$t("bills.headers.actions")}`,
          value: "actions",
          sortable: false,
        },
      ],
      user: {},
      deleteDialog: false,
      bills: [],
      delete_id: null,
      types: {
        1: "One Time",
        2: "Monthly",
        3: "Yearly"
      },
      menu: false,
      date: null,
    };
  },
  watch: {
    date: function() {
      this.getBills();
    }
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getBills() {
      let month, year;

      this.date ? month = moment(this.date,"YYYY-MM").get('month')+1 : "";
      this.date ? year = moment(this.date,"YYYY-MM").get('year') : "";

      let url = `societyadmin/bills?society_id=${this.user.id}&perPage=99999999999`;

      this.date ? url = url + `&month=${month}&year=${year}` : "";

      let _self = this;
      _self.$axios
        .get(url)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.bills = data.bills;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
            if (data.type == "invalid") {
              localStorage.removeItem("user");
              _self.$router.push({ path: "/societyadmin/login" });
            }
          }
        });
    },
    getFormattedDate(date) {
      return date ? moment(date).format("DD-MM-YYYY hh:mm A") : "N/A";
    },
    calculateDueDate(created_at, due_days) {
      console.log(created_at)
      console.log(due_days)

    if (created_at && due_days) {
      return moment(created_at).add(due_days, 'days').format("DD-MM-YYYY");
    }
    return "N/A";
  },
    sessionStorage(search) {
      if (!search) {
        sessionStorage.removeItem("bill_search");
      } else {
        sessionStorage.setItem("bill_search", search);
      }
    },
    confirmDelete(id) {
      this.deleteDialog = true;
      this.delete_id = id
    },

    deleteBill(billId) {
      let _self = this;
      _self.$axios
        .delete("societyadmin/bills/" + billId)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            this.getBills()
            this.deleteDialog = false;
            this.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
  },


  mounted() {
    this.user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    this.getBills();
    this.search = sessionStorage.getItem("bill_search");
  },
};
</script>
